import { render, staticRenderFns } from "./SerahTerimaGadaiLunas.vue?vue&type=template&id=6a96ec98&"
import script from "./SerahTerimaGadaiLunas.vue?vue&type=script&lang=js&"
export * from "./SerahTerimaGadaiLunas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports